import { render } from "./Consejo.vue?vue&type=template&id=ca33c460&scoped=true"
import script from "./Consejo.vue?vue&type=script&lang=js"
export * from "./Consejo.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=ca33c460&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca33c460"]])

export default __exports__